module.exports = __webpack_public_path__ + "Roboto-Regular.6a561d68369fd1fb9768.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-Regular.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Regular.eot
// module chunks = styles